var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "container" } },
    [
      _vm.showSteps
        ? _c(
            "div",
            { attrs: { id: "steps" } },
            _vm._l(_vm.steps, function(step, stepIndex) {
              return _c(
                "div",
                {
                  staticClass: "step",
                  class: { passed: _vm.currentStep > step.step }
                },
                [
                  _c(
                    "div",
                    {
                      class:
                        _vm.currentStep >= step.step
                          ? "bg-primary text-white"
                          : ""
                    },
                    [_vm._v("\n        " + _vm._s(stepIndex + 1) + "\n      ")]
                  ),
                  _c("q-icon", {
                    attrs: {
                      name: step.icon,
                      color: _vm.currentStep >= step.step ? "primary" : "gray",
                      size: "42px"
                    }
                  })
                ],
                1
              )
            })
          )
        : _vm._e(),
      !_vm.error && _vm.user.id
        ? _c(
            "q-carousel",
            {
              ref: "carousel",
              attrs: {
                arrows: false,
                autoplay: false,
                "quick-nav": false,
                "no-swipe": true,
                "handle-arrow-keys": false
              }
            },
            [
              !_vm.hideStepOne
                ? _c("q-carousel-slide", [
                    _c(
                      "div",
                      [
                        _c(
                          "bj-form",
                          {
                            ref: "form",
                            attrs: {
                              "gutter-size": "xs",
                              fields: _vm.fields,
                              data: _vm.payload
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.setPassword($event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-12",
                                attrs: { slot: "start" },
                                slot: "start"
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "no-margin underline-title text-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n              Hey " +
                                        _vm._s(_vm.user.first_name) +
                                        "!\n            "
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "q-ma-none q-mt-sm" }, [
                                  _vm._v(
                                    "\n              Choose a password to your account.\n            "
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-12",
                                attrs: { slot: "end" },
                                slot: "end"
                              },
                              [
                                _c("q-btn", {
                                  staticClass: "full-width",
                                  attrs: {
                                    "no-caps": "",
                                    loading: _vm.loading,
                                    push: "",
                                    rounded: "",
                                    color: "primary",
                                    label: "Create account",
                                    "icon-right": "chevron_right"
                                  },
                                  on: { click: _vm.setPassword }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              !_vm.hideStepTwo
                ? _c("q-carousel-slide", [
                    _c("div", [
                      _c(
                        "h5",
                        { staticClass: "no-margin underline-title text-bold" },
                        [_vm._v("\n          Agent Addendum\n        ")]
                      ),
                      _vm.currentStep === 2 && _vm.user.addendum_contract
                        ? _c("iframe", {
                            staticClass: "w-100 q-mt-sm",
                            staticStyle: { height: "500px" },
                            attrs: {
                              sandbox:
                                "allow-top-navigation allow-scripts allow-forms allow-same-origin",
                              src: _vm.user.addendum_contract.sign_page_url
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              !_vm.hideStepThree
                ? _c("q-carousel-slide", [
                    _c("div", [
                      _c(
                        "h5",
                        { staticClass: "no-margin underline-title text-bold" },
                        [_vm._v("\n          Setup a payout method\n        ")]
                      ),
                      _c("p", { staticClass: "q-ma-none q-mt-sm" }, [
                        _vm._v(
                          "\n          In order for us to pay you promptly and securely, you will need to register with Stripe.\n          You will be required to enter your bank account to which we will transfer your earnings.\n        "
                        )
                      ]),
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.stripeAccountLink, target: "_top" }
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width q-mt-md",
                            attrs: {
                              "no-caps": "",
                              loading: _vm.loading,
                              push: "",
                              rounded: "",
                              color: "primary",
                              label: "Setup a Stripe account",
                              "icon-right": "chevron_right"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _c("q-carousel-slide", [
                _c("div", { attrs: { id: "grid" } }, [
                  _c("div", [
                    _c(
                      "h5",
                      { staticClass: "no-margin underline-title text-bold" },
                      [
                        _vm._v(
                          "\n            Download the Showdigs mobile app\n          "
                        )
                      ]
                    ),
                    _c("p", { staticClass: "q-ma-none q-mt-sm" }, [
                      _vm._v(
                        "\n            Welcome to the team! Download our app to start earning some extra cash.\n          "
                      )
                    ])
                  ]),
                  _vm.$store.getters["app/settings"] &&
                  _vm.$store.getters["app/settings"].length
                    ? _c("div", { attrs: { id: "buttons" } }, [
                        _c("div", [
                          _vm.$q.platform.is.desktop ||
                          _vm.$q.platform.is.android
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    { name: "ripple", rawName: "v-ripple" }
                                  ],
                                  staticClass: "relative-position inline-block",
                                  attrs: { href: _vm.androidUrl }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/statics/google-play-badge.png"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]),
                        _c("div", [
                          _vm.$q.platform.is.desktop || _vm.$q.platform.is.ios
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    { name: "ripple", rawName: "v-ripple" }
                                  ],
                                  staticClass: "relative-position inline-block",
                                  attrs: { href: _vm.iosUrl }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/statics/app-store-badge.svg"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ],
            1
          )
        : _vm.error
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("p", [
                _vm._v("\n      " + _vm._s(_vm.error.message) + "\n    ")
              ]),
              _c("q-btn", {
                attrs: {
                  icon: _vm.error.buttonIcon,
                  label: _vm.error.buttonText,
                  color: _vm.error.buttonColor
                },
                on: { click: _vm.error.handler }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.loading } },
        [
          _c("q-spinner-puff", { attrs: { size: "80px", color: "primary" } }),
          _c("div", { staticClass: "q-mt-md text-primary text-bold" }, [
            _vm._v("\n      Please wait...\n    ")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }